import React, { Component } from 'react'
import RestApiUtils from "../../apiclient/moebli/RestApiUtils"
import OpenAIPageUI from './OpenAIPageUI'

class OpenAIPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      prompt: '',
      textList: [],
    }
  }

  render() {
    return (
      <OpenAIPageUI
        context={this.props.context}
        onSubmit={this.onSubmit}
        textList={this.state.textList}
        errorList={this.state.errorList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onSubmit = (prompt) => {
    this.setState({prompt: prompt})
    let context = this.props.context
    RestApiUtils.get(
      this.props.context,
      `/api/accounts/${context.session.accountId}/openAIs?prompt=${prompt}`,
      this.getSubmitCallback,
      null,
      {prompt: prompt}
    )
  }

  getSubmitCallback = (response) => {
    let text = response.openAIDTOList[0].text
    this.state.textList.unshift(text)
    let prompt = this.state.prompt
    this.state.textList.unshift(prompt)
    this.setState({textList: this.state.textList, prompt: ''})
  }

  onRefreshClick = () => {
    let context = this.props.context
    //CacheManager.removeObject(CacheKeys.ChatUser())
    this.setState({
      errorList: null,
      //chatUser: null,
    }, () => {
      //this.getChatUser(context)
    })
  }
}

export default OpenAIPageSF
